import { DecoderOption } from '@/types/hydraulic'

// DECISION: decoder tuple fields (address, index, twiId) are still sent next to decoderId, not dropped, because a backend without vnv-cisgenics-BE#405 ignores decoderId and still reads the tuple. DEPRECATED SOON: drop the tuple once #405 is on production (SCRUM-1022 / SCRUM-1169).

type DecoderLike = {
  id?: string | null
  address?: number | string | null
  index?: number | string | null
  twiId?: number | string | null
}

const sameNumber = (a: unknown, b: unknown) => (Number(a) || 0) === (Number(b) || 0)

export const matchesDecoder = (
  option: DecoderLike,
  address: unknown,
  index: unknown,
  twiId?: unknown,
) =>
  sameNumber(option.address, address) &&
  sameNumber(option.index, index) &&
  sameNumber(option.twiId, twiId)

export const findDecoderOption = <T extends DecoderLike>(
  options: T[] | null | undefined,
  address: unknown,
  index: unknown,
  twiId?: unknown,
) => options?.find((option) => matchesDecoder(option, address, index, twiId))

export const withDecoderId = <T extends DecoderLike>(
  option: T | undefined,
  options: DecoderLike[] | null | undefined,
): T | undefined => {
  if (!option || option.id) return option
  const found = findDecoderOption(options, option.address, option.index, option.twiId)
  return found?.id ? { ...option, id: found.id } : option
}

export const hasDecoderLink = (option?: DecoderLike | null) =>
  !!option && (!!option.id || (Number(option.address) > 0 && Number(option.index) > 0))

export const storedDecoderOrUndefined = <T extends DecoderLike>(option: T) =>
  hasDecoderLink(option) ? option : undefined

export const resolveStoredDecoder =<T extends DecoderLike>(
  stored: T | null | undefined,
  options: T[] | null | undefined,
): T | undefined => {
  if (!stored) return undefined
  if (stored.id) {
    const byId = options?.find((option) => option.id === stored.id)
    return byId ? { ...stored, ...byId } : stored
  }
  if (!Number(stored.address) || !Number(stored.index)) return undefined
  return withDecoderId(stored, options)
}

export const decoderLinkFields =(option?: DecoderLike | DecoderOption | null) => ({
  decoderId: option?.id || undefined,
  address: Number(option?.address) || 0,
  index: Number(option?.index) || 0,
  twiId: option?.twiId != null ? Number(option.twiId) : null,
})

export const fertigationDecoderFields = (option?: DecoderLike | null) => ({
  decoderId: option?.id || undefined,
  address: Number(option?.address) || 0,
  controllerId: Number(option?.index) || 0,
})

export const rainDecoderFields = (option?: DecoderLike | null) => ({
  rainDecoderId: option?.id || undefined,
  rainAddr: Number(option?.address) || 0,
  rainIdx: Number(option?.index) || 0,
  ...(option?.twiId != null && { rainTwiId: Number(option.twiId) }),
})
